import { withHandlers } from 'recompose'
import { scroller } from 'react-scroll'

export default withHandlers({
  loadLoginHistory: props => userId => {
    if (!props.loginHistoryList.length) {
      props.getLoginHistory({
        size: props.loginHistoryItemsPerPage,
        userId: userId || props.user.id,
        page: props.loginHistoryCurrentPage
      })
    }
  },
  handleLoginHistoryPageClick: props => ({ selected }, userId) => {
    props.getLoginHistory({
      size: props.loginHistoryItemsPerPage,
      userId: userId || props.user.id,
      page: selected + 1
    })
    .then(() => {
      scroller.scrollTo('login-history', {
        duration: 500,
        delay: 0,
        smooth: 'easeInOutQuart'
      })
    })
  },
})



// WEBPACK FOOTER //
// ./components/hoc/loadLoginHistoryHandler.js